export class QuoteEndpoints {
  static readonly cardToken = '/cardtoken/tokenise';

  static Quote(brand: string, quoteId?: string): string {
    const url = `/${brand.toLowerCase()}/quote`;
    return quoteId ? `${url}/${quoteId}` : url;
  }

  static Purchase(brand: string): string {
    return `/${brand.toLowerCase()}/purchase`;
  }

  static Error(brand: string): string {
    return `/${brand.toLowerCase()}/error`;
  }
  static Communication(brand: string, quoteId: string): string {
    return `/${brand.toLowerCase()}/quote/${quoteId}/communication`;
  }
}
